// src/components/CartModal.jsx
import React from 'react';
import { X, Minus, Plus, Trash2 } from 'lucide-react';

import { theme } from '../utils/constants';

export default function CartModal({
  isOpen,
  closeCart,
  cartItems,
  updateQuantity,
  removeFromCart,
  getTotalPrice,
  navigateTo
}) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '100%',
        maxWidth: '420px',
        height: '100%',
        background: 'white',
        boxShadow: '-8px 0 32px rgba(0,0,0,0.25)',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '1.5rem 1.8rem',
          background: `linear-gradient(135deg, ${theme.primaryDark}, ${theme.primary})`,
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600 }}>Your Cart</h3>
        <button
          onClick={closeCart}
          style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}
        >
          <X size={28} />
        </button>
      </div>

      {/* Cart Items List */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem' }}>
        {cartItems.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#777', margin: '4rem 0' }}>
            Your cart is empty
          </p>
        ) : (
          cartItems.map(item => (
            <div
              key={item.variantId || item.id}
              style={{
                display: 'flex',
                marginBottom: '1.5rem',
                paddingBottom: '1.5rem',
                borderBottom: `1px solid ${theme.border}`
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: '80px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  marginRight: '1rem'
                }}
              />
              <div style={{ flex: 1 }}>
                <h4 style={{ margin: '0 0 0.4rem', fontSize: '1.1rem' }}>
                  {item.title}
                  {(item.selectedSize || item.selectedColor) && (
                    <div style={{ fontSize: '0.9rem', color: theme.textLight, marginTop: '0.3rem' }}>
                      {item.selectedSize && `Size: ${item.selectedSize}`}
                      {item.selectedSize && item.selectedColor && ' • '}
                      {item.selectedColor && `Color: ${item.selectedColor}`}
                    </div>
                  )}
                </h4>

                <p style={{ color: theme.primary, fontWeight: 600, margin: '0.4rem 0' }}>
                  zmk {item.price.toFixed(2)}
                </p>

                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div
                    style={{
                      display: 'flex',
                      border: `1px solid ${theme.border}`,
                      borderRadius: '50px'
                    }}
                  >
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      style={{
                        padding: '0.5rem 0.9rem',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <Minus size={16} />
                    </button>
                    <span
                      style={{
                        padding: '0.5rem 1rem',
                        minWidth: '40px',
                        textAlign: 'center',
                        fontWeight: 600
                      }}
                    >
                      {item.quantity}
                    </span>
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      style={{
                        padding: '0.5rem 0.9rem',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <Plus size={16} />
                    </button>
                  </div>

                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{ color: '#999', background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    <Trash2 size={20} />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer with Total & Checkout Button */}
      {cartItems.length > 0 && (
        <>
          <div
            style={{
              padding: '1.5rem',
              borderTop: `1px solid ${theme.border}`,
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '1.3rem',
              fontWeight: 600
            }}
          >
            <span>Total:</span>
            <span style={{ color: theme.primary }}>zmk {getTotalPrice()}</span>
          </div>

          <div style={{ padding: '0 1.5rem 1.8rem' }}>
            <button
              onClick={() => {
                navigateTo('checkout');
                closeCart();
              }}
              style={{
                width: '100%',
                background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
                color: '#111',
                border: 'none',
                padding: '1.1rem',
                borderRadius: '50px',
                fontSize: '1.1rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Proceed to Checkout
            </button>
          </div>
        </>
      )}
    </div>
  );
}